import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-border bg-card mt-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <h3 className="font-serif text-4xl md:text-5xl font-light leading-tight">
              Gulhar<br />
              <span className="italic text-primary">Furniture House</span>
            </h3>
            <p className="mt-6 text-muted-foreground max-w-sm text-sm leading-relaxed">
              Handcrafted furniture for the considered home. Solid wood, honest joinery, and pieces made to be lived with for a lifetime.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs tracking-[0.3em] uppercase text-primary mb-6">Explore</p>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li><Link to="/" className="hover:text-foreground" data-testid="footer-home">Home</Link></li>
              <li><Link to="/collection" className="hover:text-foreground" data-testid="footer-collection">Collection</Link></li>
              <li><Link to="/contact" className="hover:text-foreground" data-testid="footer-contact">Contact</Link></li>
              <li><Link to="/admin/login" className="hover:text-foreground" data-testid="footer-admin">Admin</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs tracking-[0.3em] uppercase text-primary mb-6">Visit the showroom</p>
            <ul className="space-y-4 text-sm text-muted-foreground">
              <li className="flex items-start gap-3"><MapPin size={18} className="text-primary mt-0.5 shrink-0" /> Residency Road, Srinagar, Jammu &amp; Kashmir 190001</li>
              <li className="flex items-center gap-3"><Phone size={18} className="text-primary shrink-0" /> +91 98765 43210</li>
              <li className="flex items-center gap-3"><Mail size={18} className="text-primary shrink-0" /> hello@gulharfurniture.com</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-border flex flex-col md:flex-row justify-between gap-4 text-xs text-muted-foreground">
          <span>© {new Date().getFullYear()} Gulhar Furniture House. All rights reserved.</span>
          <span className="tracking-wide">Crafted in Kashmir · Delivered nationwide</span>
        </div>
      </div>
    </footer>
  );
}
